import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faFile } from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row } from 'reactstrap';

//Context
import { useAuth } from '../../../../../context/auth';

//Componentes
import TextField from '../../../../../components/TextField';
import TabelaListagem from '../../../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../../../components/Modal/Modal';

//Helpers
import uuid from '../../../../../helpers/guid';
import { showMessage, showQuestion } from '../../../../../helpers/message';
import { objCampo, validarCampos } from '../../../../../helpers/ValidadorDeCampos';
import mascaras from '../../../../../helpers/mascaras';
//API
import documento_api from '../../../../../api/documento_api';
import roteiroDeFiscalizacao_api from '../../../../../api/roteiroDeFiscalizacao_api';

//Contants
import { actionsTable } from '../../../../../constants/MaterialTable';
import formulario_api from '../../../../../api/formulario_api';


function initialStateEtapa(uuid) {
    return {
        descricao: "",
        prazoDias: "",
        excluido: "false",
        avancaEtapaPrazoExcedido: "false",
        roteiroFiscalizacao_Id: "",
        formulario_Id: "Nenhum",
        hash: uuid,
        responsavel: "Secretaria",
        andamento: "Inicial",
        documentos: [],
        sequenciaDashboard: "0",
        exigeVotacaoColegiado: "false",
        exibirEtapaInfrator: "false",
        calcularJuros: "false",
        permiteAlterarEmail: "false",
        reenvioEmailAutomatico: "false",
        inicioPrazoProximoDiaUtil: "false",
        fimPrazoProximoDiaUtil: "false",
    }
}

const initialStateDocumento = (roteiroFiscalizacaoEtapa_id) => {
    return {
        ...roteiroFiscalizacaoEtapa_id ? { roteiroFiscalizacaoEtapa_Id: roteiroFiscalizacaoEtapa_id } : {},
        documento_Id: "",
        obrigatorio: "false",
    }
}


function Etapas({ roteiroFiscalizacao, loadRoteiroFiscalizacao, editavel }) {
    const [etapa, setEtapa] = useState(initialStateEtapa(uuid()));

    const { setLoading } = useAuth();

    //Estado de controle de visibilidade do modal dos documentos
    const [visibleModal, setVisibleModal] = useState(false);

    //Estado de controle de visibilidade do formulario de cadastro de etapa
    const [visibleContainer, setVisibleContainer] = useState(false);

    //Estado de controle dos dados do documento a ser adicionado na lista
    const [documento, setDocumento] = useState(initialStateDocumento(etapa.id));

    //Estado de controle das opções de documentos
    const [documentos, setDocumentos] = useState([]);

    //Estado de controle dos erros nos campos obrigatorios de cadastro de etapa
    const [errors, setErrors] = useState({});

    //Estado de controle dos erros nos campos do documento
    const [errorsDocumento, setErrosDocumento] = useState({});

    //State para pegar formularios cadastrados
    const [listaFormularios, setListaFormularios] = useState([]);

    //Função de troca de visibilidade do modal
    const toggleModal = () => {
        setVisibleModal(!visibleModal);
    };

    //Função que carrega a lista de documentos
    const loadDocumentos = () => {
        setLoading(true);
        documento_api.getListAtivos().then(response => {
            response.data.map(value => {
                value.value = value.id.toString();
                value.label = value.identificacao;

                return value;
            })
            setDocumentos(response.data);
        })
            .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
            .finally(() => setLoading(false));
    }

    const loadFormulario = () => {
        setLoading(true);
        formulario_api.GetListAtivosByFinalidade("Análise").then(response => {
            response.data.map(value => {
                value.label = value.identificacao;
                value.value = value.id.toString();
                return value;
            })
            setListaFormularios([...response.data, { label: "Nenhum", value: "Nenhum" }]);
        })
            .catch(ex => showMessage("Erro", ex.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDocumentos();
        loadFormulario();
    }, [])


    //Estado de controle de troca de exibição do formulario de cadastro de etapa
    const toggleFormContainer = () => {
        setVisibleContainer(!visibleContainer);
        if (visibleContainer)
            setEtapa(initialStateEtapa(uuid()));
    }

    //onChange para o documento a ser adicionado
    const onChangeDocumento = (value, e) => {
        setDocumento({
            ...documento,
            [e.name]: value ? value.value.toString() : null,
        });

    }

    const onChange = (e) => {
        const { name, value } = e.target;
        setEtapa({
            ...etapa,
            [name]: value
        })
    }

    //onChange do campo obrigatorio do documento
    const onChangeObrigatorioDocumento = (e) => {
        const { name, value } = e.target;

        setDocumento({
            ...documento,
            [name]: value
        })
    }

    const editarDocumento = (editRow) => {
        const _editRow = { ...editRow }
        _editRow.documento_Id = _editRow.documento_Id.toString();
        setDocumento(_editRow);
    }

    const removerDocumento = (questaoRemove) => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar esse documento?", "info",
            (confirmation) => {
                if (confirmation) {
                    setEtapa({
                        ...etapa,
                        documentos: etapa.documentos.filter(value => value.tableData.id != questaoRemove.tableData.id)
                    });
                }
            })
    }

    //Actions da tabela de documentos
    const actionsDocumentos = [
        actionsTable.editar(editarDocumento),
        actionsTable.remover(removerDocumento)
    ];

    //Função do botão de editar etapa
    const editar = (rowData) => {
        if (!rowData?.exigeVotacaoColegiado) {
            setEtapa({
                ...rowData,
                exigeVotacaoColegiado: false
            });
        } else {
            setEtapa(rowData);
        }
        setVisibleContainer(true);
    }

    const visualizar = (rowData) => {
        setEtapa(rowData);
        setVisibleContainer(true);
    }

    //Função do botão de remover etapa
    const remover = (rowData) => {
        showQuestion("Tem certeza?", "Tem certeza de que deseja deletar essa etapa?\n Esta ação é irreversível", "info",
            (confirmation) => {
                if (confirmation) {
                    roteiroDeFiscalizacao_api.DeleteRoteiroFiscalizacaoEtapa(rowData.id)
                        .then(response => {
                            showMessage("Sucesso", "Etapa deletada com sucesso", 'success', () => {
                                toggleFormContainer();
                                loadRoteiroFiscalizacao();
                            });
                        })
                        .catch(err => showMessage("Aviso", err.message, "error", null))
                        .finally(() => setLoading(false));
                }
            })
    }

    //Ações que a tabela terá
    const actions = [
        ...editavel
            ? [actionsTable.editar(editar), actionsTable.remover(remover)]
            : [actionsTable.visualizar(visualizar)]
    ];

    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Descrição", objectValue: "descricao", align: "left" },
        { value: "Prazo em dias", objectValue: "prazoDias", align: "left" },
        { value: "Responsavel", objectValue: "responsavel", align: "left" },
        { value: "Sequência dashboard", objectValue: "sequenciaDashboard", align: "left" },
    ]

    //Cabeçalhos que a tabela de documentos
    const headersDocumentos = [
        { value: "Documento", objectValue: "documento", align: "left" },
        {
            value: "Obrigatório", objectValue: "obrigatorio", align: "left", options: {
                customBodyRenderLite: (dataIndex) => {
                    return <>{etapa.documentos[dataIndex].obrigatorio ? "Sim" : "Não"}</>
                }
            }
        },
    ]

    //Campos obrigatorios
    const camposDocumento = [
        objCampo({ name: "documento_Id", required: true })
    ];

    //Campos obrigatorios
    const camposObrigatorios = [
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "responsavel", required: true })
    ];

    const onChangeFormularios = (value, e) => {
        const _etapa = {
            ...etapa,
            [e.name]: value ? value.value.toString() : null,
        };
        setEtapa(_etapa);
    }

    const onSubmitDocumento = () => {
        const _documento = { ...documento };

        const _errorsDocumento = validarCampos(_documento, camposDocumento);
        setErrosDocumento(_errorsDocumento[0]);

        if (_errorsDocumento[1].length > 0)
            return;

        if (etapa.documentos.filter(x => x.documento_Id == _documento.documento_Id && x.obrigatorio == _documento.obrigatorio && (!_documento.documento_Id || _documento.documento_Id != x.id)).length > 0) {
            showMessage("Aviso", "Este documento ja foi adicionado para este tipo de requerimento", "info", null);
            return;
        }

        const _roteiroFiscalizacaoEtapaDocumento = [...!_documento.tableData ? etapa.documentos : etapa.documentos.map(value => {
            if (value.documento_Id == _documento.documento_Id) {
                _documento.obrigatorio = _documento.obrigatorio == "true" ? true : false;
                return _documento;
            }
            return value;
        })];

        if (!_documento.tableData) {
            _roteiroFiscalizacaoEtapaDocumento.push(_documento);
        }
        setEtapa({
            ...etapa,
            documentos: _roteiroFiscalizacaoEtapaDocumento
        });
        setDocumento(initialStateDocumento(etapa.id));
    }

    const onSubmit = () => {
        const _errors = validarCampos(etapa, camposObrigatorios);
        setErrors(_errors[0]);
        if (_errors[1].length)
            return;

        setLoading(true);
        const _etapa = { ...etapa };

        _etapa.excluido = _etapa.excluido == "true";
        _etapa.roteiroFiscalizacao_Id = roteiroFiscalizacao.id;
        _etapa.formulario_Id = _etapa.formulario_Id == "Nenhum" ? null : _etapa.formulario_Id;
    
        if (_etapa.id) {
            roteiroDeFiscalizacao_api.putRoteiroFiscalizacaoEtapa(_etapa)
                .then(response => {
                    toggleFormContainer();
                    loadRoteiroFiscalizacao();
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        } else {
            roteiroDeFiscalizacao_api.postRoteiroFiscalizacaoEtapa(_etapa)
                .then(response => {
                    toggleFormContainer();
                    loadRoteiroFiscalizacao(response.data);
                })
                .catch(err => showMessage("Error", err?.message ?? "Error na operação.", "error", null))
                .finally(() => setLoading(false));
        }
    }

    return <>
        <h5 className='mb-3 d-flex align-items-center justify-content-between'>Etapas {editavel ? <Button color='success' onClick={toggleFormContainer}>+ Adicionar</Button> : <></>}</h5>
        <ModalCustomized
            btnClose={true}
            isOpen={visibleModal}
            toggle={toggleModal}
            title={"Documentos"}
        >
            <Row>
                <Col md="12" lg="8">
                    <TextField
                        label={"* Documento"}
                        name={"documento_Id"}
                        onChange={onChangeDocumento}
                        type={"select"}
                        searchable
                        options={documentos}
                        value={documentos.filter(doc => doc.value == documento.documento_Id)}
                        invalid={!!errorsDocumento.documento_Id}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        type={"select"}
                        label="* Obrigatorio"
                        name={"obrigatorio"}
                        options={
                            [
                                { label: "Sim", value: "true" },
                                { label: "Não", value: "false" }
                            ]
                        }
                        onChange={onChangeObrigatorioDocumento}
                        value={documento.obrigatorio}
                        disabled={!editavel}
                    />
                </Col>
                <Col md="12" className={`d-flex align-items-center justify-content-center mb-4 ${editavel ? "" : "d-none"}`}>
                    <Button
                        color={"secondary"}
                        className='me-4'
                        onClick={() => setDocumento(initialStateDocumento(etapa.id))}
                    >
                        cancelar
                    </Button>
                    <Button
                        onClick={onSubmitDocumento}
                        color={documento.id ? "warning text-white" : 'success'}
                    >
                        {documento.id ? <> <FontAwesomeIcon icon={faEdit} />  Editar</> : "+ Adicionar"}
                    </Button>
                </Col>
                <Col md="12" className='d-flex align-items-center justify-content-center'>
                    <TabelaListagem
                        title='Lista de documentos'
                        headers={headersDocumentos}
                        actions={actionsDocumentos}
                        items={etapa?.documentos?.length > 0 ? etapa.documentos.map(d => {
                            const _documento = documentos.filter(doc => doc.value == d?.documento_Id)
                            d.documento = _documento[0]?.identificacao
                            return d;
                        }) : []}
                    />
                </Col>
            </Row>
        </ModalCustomized>
        <div className={`formContainer ${visibleContainer ? "" : "close"} mb-2`}>
            <Row>
                <Col md={12} lg={6}>
                    <TextField
                        name={"descricao"}
                        label={"*  Descrição"}
                        type={"text"}
                        onChange={onChange}
                        value={etapa.descricao}
                        invalid={!!errors.descricao}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={6}>
                    <TextField
                        type={"select"}
                        name={"formulario_Id"}
                        label={"* Formulário"}
                        searchable
                        options={listaFormularios}
                        onChange={onChangeFormularios}
                        value={listaFormularios.filter(value => value.value == etapa.formulario_Id)}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={5}>
                    <TextField
                        name={"avancaEtapaPrazoExcedido"}
                        label={"*  Avançar automaticamente quando o prazo for excedido"}
                        type={"select"}
                        options={[
                            { value: "true", label: "Sim" },
                            { value: "false", label: "Não" }
                        ]}
                        onChange={onChange}
                        value={etapa.avancaEtapaPrazoExcedido}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"prazoDias"}
                        label={"*  Prazo em dias"}
                        type={"text"}
                        mask={mascaras.numeroMask}
                        onChange={onChange}
                        value={etapa.prazoDias}
                        invalid={!!errors.prazoDias}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"responsavel"}
                        label={"*  Responsável"}
                        type={"select"}
                        options={[
                            { value: "Secretaria", label: "Secretaria" },
                            // { value: "APP", label: "APP" },
                            { value: "Sistema", label: "Sistema" },
                            { value: "Fiscalizado", label: "Fiscalizado" }
                        ]}
                        onChange={onChange}
                        value={etapa.responsavel}
                        invalid={!!errors.responsavel}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"andamento"}
                        label={"*  Andamento"}
                        type={"select"}
                        options={[
                            { value: "Inicial", label: "Inicial" },
                            { value: "Processo", label: "Processo" },
                            { value: "Final", label: "Final" }
                        ]}
                        onChange={onChange}
                        value={etapa.andamento}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"exigeVotacaoColegiado"}
                        label={"* Exige votação por órgão colegiado"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.exigeVotacaoColegiado}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"exibirEtapaInfrator"}
                        label={"* Exibe para o Infrator"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.exibirEtapaInfrator}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"calcularJuros"}
                        label={"* Calcular Juros"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.calcularJuros}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"permiteAlterarEmail"}
                        label={"* Permite alterar E-mail"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.permiteAlterarEmail}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={3}>
                    <TextField
                        name={"reenvioEmailAutomatico"}
                        label={"* Reenvio Automático de Email"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.reenvioEmailAutomatico}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"inicioPrazoProximoDiaUtil"}
                        label={"* Início do prazo no próximo dia útil"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.inicioPrazoProximoDiaUtil}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={4}>
                    <TextField
                        name={"fimPrazoProximoDiaUtil"}
                        label={"* Fim do prazo no próximo dia útil"}
                        type={"select"}
                        options={[
                            { label: "Sim", value: "true" },
                            { label: "Não", value: "false" }
                        ]}
                        onChange={onChange}
                        value={etapa.fimPrazoProximoDiaUtil}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2}>
                    <TextField
                        name={"sequenciaDashboard"}
                        label={"* Sequência dashboard"}
                        type={"text"}
                        mask={mascaras.numeroMask}
                        onChange={onChange}
                        value={etapa.sequenciaDashboard}
                        disabled={!editavel}
                    />
                </Col>
                <Col md={12} lg={2} className='mt-2'>
                    <Button
                        className='w-100'
                        color='primary'
                        onClick={() => setVisibleModal(true)}
                    >
                        <FontAwesomeIcon icon={faFile} /> Documentos
                    </Button>
                </Col>
                <Col md={12} lg={12} className={`d-flex align-items-center justify-content-center mb-3 ${editavel ? "" : "d-none"}`}>
                    <Button className='me-4' color={"secondary"} onClick={toggleFormContainer}>
                        Cancelar
                    </Button>
                    <Button color={etapa.id ? "warning text-white" : 'success'} onClick={onSubmit}>
                        {etapa.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"}
                    </Button>
                </Col>
            </Row>
        </div>
        <TabelaListagem
            actions={actions}
            title={"Lista de etapas"}
            options={{ print: false, search: true, pagination: true }}
            headers={headers}
            items={roteiroFiscalizacao.etapas}
        />
    </>;
}

export default Etapas;